import * as React from "react";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load}             from "@Common/react/load";
import {SearchableSelect} from "@Common/ui-components/searchable-select/searchable-select";
import {sortMulti}        from "@Common/utils/collections";
import {chain}            from "@Common/utils/fs";

import {showOfficeEmulation} from "../../../../../common/logic/show-office-emulation";

export const BranchSelectDropdown = ({filter, onChanged=undefined}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["multiBranch", ({userLevels}, next) => next(showOfficeEmulation(userLevels))],
    ["branchList", ({multiBranch, apis}, next) => Load({
        fetch: async () => await (multiBranch) ? apis.next.getBranchList({activeOfficesOnly: true, includeDeletedOffices: false}) : [],
        next,
    })],
    ["filteredBranchList", ({branchList}, next) => branchList && next(handleBranchFilter({branchList, filter}))],
    ({session, isInternalUser, filteredBranchList}) => (
        SearchableSelect({
            getSublabel: (branch) => (<>
                {displaySubLabel({branch}) && <div>
                    {[
                        branch.branchAddress1,
                        branch.branchAddress2,
                        branch.branchCity,
                        branch.branchState,
                        branch.branchZip,
                    ].filter(Boolean).join(", ")}
                </div>}
                {displaySubLabel({branch}) && <div
                    xd-qa-type="dropdown_item"
                    xd-qa-name={`Office ${branch.idBranch}`}
                >
                    {branch.branchLinkId} {isInternalUser && `| Internal ID: ${branch.idBranch}`}
                </div>}
            </>),
            list: chain(
                filteredBranchList ?? (session.data.branchName ? [{idBranch: session.value.branchId, branchName: session.data.branchName}] : []),
                (_) => {
                    let branches = sortMulti(_, [
                        (branch) => branch["branchName"]?.toLowerCase(),
                    ])
                    branches.length > 1 && branches.unshift({idBranch: "ALL", branchName: "All offices"})
                    return branches
                },
            ),
            loading: !filteredBranchList,
            placeholder: "Please select an office",
            getLabel: (branch) => chain(
                branch.branchName || branch.branchLinkId,
                (label) => <span title={label} xd-qa-type="dropdown_item" xd-qa-name={`Office ${label}`}>{label}</span>
            ),
            mapSearchAsItemFilter: (search:string) => {
                const searchLowercase = search.toLowerCase();
                return (branch) => (isInternalUser && branch.idBranch.includes(searchLowercase)) || [
                    "branchName",
                    "branchLinkId",
                    "branchAddress1",
                    "branchAddress2",
                    "branchCity",
                    "branchState",
                ].some(field => branch[field]?.toLowerCase().includes(searchLowercase))
            },
            onSelect: async (branch) => {
                filter.onChange(!branch ? {
                    ...filter.value,
                    idBranch: '',
                } : {
                    ...filter.value,
                    idBranch: branch.idBranch,
                });
                onChanged?.();
            },
            isSelected: (branch) => filter.value?.idBranch === branch.idBranch,

            className: "office",
            searchLabel: "Search an office",
            xdQaName: "Office",
            allowClear: true,
            scrollCloses: false,
        })
    )
);

const displaySubLabel = ({branch}) => {
    return branch.idBranch !== "ALL";
}

const handleBranchFilter = ({branchList, filter}) => {
    if(filter.value.idRegion === "ALL") return branchList;
    return filter.value.idRegion ? branchList.filter((d) => d.idRegion === filter.value.idRegion) : branchList;
}